import {InjectionToken} from '@angular/core';

export const API_AUTH_GUARD_PUBLIC_ONLY_ROUTES = new InjectionToken<RegExp>('API_AUTH_GUARD_PUBLIC_ONLY_ROUTES');
